import Vue from 'vue'
import Router from 'vue-router'
import index from '@/components/index'
import main from '@/components/main'
import introduce from '@/components/introduce'
import about from '@/components/about'
import process from '@/components/process'
import vote from '@/components/vote'
import mycenter from '@/components/mycenter'
import myteam from '@/components/myteam'
import answer from '@/components/answer/Answer'
import video from '@/components/video/video'
import promotion from '@/components/promotion'
Vue.use(Router)

export default new Router({
    routes: [{
        path: '/',
        name: '',
        component: index,
        redirect: '/main',
        children: [{
                path: '/main',
                name: '首页',
                active: 1,
                component: main
            },
            {
                path: '/promotion',
                name: '获奖名单',
                acrive: 7,
                component: promotion
            },
            {
                path: '/introduce',
                name: '大赛介绍',
                active: 2,
                component: introduce
            }, {
                path: '/process',
                name: '大赛流程',
                active: 3,
                component: process
            },
            {
                path: '/vote',
                name: '人气投票',
                active: 4,
                component: vote
            },
            {
                path: '/about',
                name: '关于全国大赛',
                active: 5,
                component: about
            }, {
                path: '/mycenter',
                name: '',
                active: 6,
                component: mycenter
            }, {
                path: '/myteam',
                name: '',
                active: 6,
                component: myteam
            }
        ]
    }, {
        path: '/answer',
        name: '答题',
        component: answer
    }, {
        path: '/onlineVideo',
        name: '在线学习',
        component: video
    }]
})


// WEBPACK FOOTER //
// ./src/router/index.js